import React from "react";
import { useTranslation } from "react-i18next";
import { ActivityEvent } from "../../features/admin/models/AdminUserActivity";
import { formatAdminTimestamp } from "../../features/admin/utils/formatAdminTimestamp";

interface AdminActivityTimelineProps {
  events: ActivityEvent[];
}

/** Created-at entries of every kind, newest first — kinds only, no names. */
const AdminActivityTimeline: React.FC<AdminActivityTimelineProps> = ({ events }) => {
  const { t } = useTranslation();

  return (
    <div className="with-border rounded-2xl p-4 lg:p-6">
      <h2 className="text-lg font-semibold text-grey-10 dark:text-white">
        {t("admin.activity.timeline")}
      </h2>
      {events.length === 0 ? (
        <p className="py-6 text-center text-grey-40 dark:text-grey-70">
          {t("admin.activity.never")}
        </p>
      ) : (
        <ul className="mt-2 divide-y divide-grey-90 dark:divide-primary-20">
          {events.map((event, index) => (
            <li
              key={`${event.kind}-${event.createdAt.getTime()}-${index}`}
              className="flex flex-wrap items-center justify-between gap-2 py-2"
            >
              <span className="text-grey-10 dark:text-white">
                {t(`admin.activity.kind.${event.kind}`, { defaultValue: event.kind })}
              </span>
              <span className="text-sm text-grey-30 dark:text-grey-70">
                {formatAdminTimestamp(event.createdAt)}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AdminActivityTimeline;
